import { defineMessages } from 'react-intl';

export default defineMessages({
    wishToContinue: {
        id: 'app.components.teacherUnassign.wishToContinue',
        defaultMessage: 'Do you wish to continue?'
    }
});



// WEBPACK FOOTER //
// ./app/components/teacher-unassign/messages.js